import { render } from "./Pagination2.vue?vue&type=template&id=b1450d8c"
import script from "./Pagination2.vue?vue&type=script&lang=js"
export * from "./Pagination2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__